// Build-the-set / build-the-stack module tracking (August 2026).
//
// One tracker for both bundle builders — pillow-build-set ("Build the set")
// and mattress-stack-builder ("Build the stack") — across all seven surfaces
// they render on: the pillow and mattress-pad collection pages (mode "pair")
// and the five product pages they lock to (mode "system": FluffBase,
// CloudSupport, FlexCool, TempTune, Eucalyptus Protector).
//
// The sections never touch dataLayer themselves. They push plain
// {name, detail} records onto window.__buildSetQueue, which starts life as an
// array so events fired before this deferred script parses are not lost; this
// file drains that array and then replaces it with a live sink.
//
// Funnel, in order:
//   build_set_view          module reached 50% viewport (once per instance / pageview)
//   build_set_engage        first configuration change   (once per instance / pageview)
//   build_set_step          every configuration change   (field + value)
//   build_set_add_to_cart   cart POST succeeded, carries a GA4 ecommerce block
//   build_set_add_error     cart POST failed
//   build_set_cross_click   cross-sell card on the module
//   build_set_isla_click    Isla card on the module (see also entry_point in the advisor)
(function () {
  if (window.__buildSetTrackingInit) return;
  window.__buildSetTrackingInit = true;

  var CURRENCY =
    (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';

  // Once-per-pageview guards, keyed per section instance so two builders on one
  // page (the PDP template carries both, only one renders) stay independent.
  var viewed = {};
  var engaged = {};

  function dollars(cents) {
    return Math.round(Number(cents) || 0) / 100;
  }

  // Config objects arrive as ordered key/value pairs; flatten to one readable
  // GA4 string ("size=queen|topper=TempTune|sheets=AiryWeight") since GA4 event
  // parameters cannot hold nested objects.
  function configString(config) {
    if (!config) return undefined;
    var out = [];
    Object.keys(config).forEach(function (k) {
      var v = config[k];
      if (v === null || v === undefined || v === '') return;
      out.push(k + '=' + String(v));
    });
    return out.length ? out.join('|') : undefined;
  }

  function base(d) {
    return {
      bs_module: d.module, // pillow_build_set | mattress_stack_builder
      bs_mode: d.mode, // pair (collection) | system (locked to a PDP)
      bs_surface: d.surface, // collection | product
      bs_handle: d.handle, // collection or product handle the module ran on
      bs_section_id: d.sectionId
    };
  }

  function emit(payload) {
    (window.dataLayer = window.dataLayer || []).push(payload);
  }

  function handle(evt) {
    var name = evt && evt.name;
    var d = (evt && evt.detail) || {};
    if (!name || !d.module) return;
    var key = d.module + ':' + d.sectionId;

    if (name === 'view') {
      if (viewed[key]) return;
      viewed[key] = true;
    }
    if (name === 'engage') {
      if (engaged[key]) return;
      engaged[key] = true;
    }

    var payload = base(d);
    payload.event = 'build_set_' + name;

    if (d.config) {
      payload.bs_config = configString(d.config);
      payload.bs_size = d.config.size;
    }
    if (d.field) payload.bs_field = d.field;
    if (d.value !== undefined) payload.bs_value = String(d.value);
    if (d.itemCount !== undefined) payload.bs_item_count = d.itemCount;
    if (d.message) payload.bs_error = String(d.message).slice(0, 140);
    if (d.label) payload.bs_label = d.label;

    if (name === 'add_to_cart' && d.items && d.items.length) {
      // GA4 wants the previous ecommerce object cleared before a new one lands,
      // otherwise stale items leak into the next push.
      emit({ ecommerce: null });
      payload.ecommerce = {
        currency: CURRENCY,
        value: dollars(d.total),
        items: d.items.map(function (item, i) {
          return {
            item_id: String(item.id),
            item_name: item.name,
            item_variant: item.config,
            item_list_name: d.module,
            item_list_id: d.module + ':' + d.mode,
            index: i,
            price: dollars(item.price),
            quantity: 1
          };
        })
      };
    }

    emit(payload);
  }

  var queued = window.__buildSetQueue;
  window.__buildSetQueue = {
    push: function (evt) {
      handle(evt);
      return 1;
    }
  };
  if (queued && queued.length) queued.forEach(handle);
})();
